<div class="cb-goal-form">
  <!-- Input Group -->
  <div class="input-group">
    <label class="input-label"> Briefly describe what you want to achieve. </label>
    <div class="textarea-container">
      <textarea
        class="goal-textarea"
        placeholder="Tell me about your challenge."
        (input)="onGoalInput($event)"
        (keydown.enter)="onEnterKey($event)"
        [value]="goalText()"
      ></textarea>
      @if (useAi()) {
        <oph-button
          class="go-button"
          [color]="'green'"
          [size]="'medium'"
          [disabled]="!goalText()"
          [loading]="onGoLoading()"
          [style]="{minWidth: '0', width: '80px', padding: '0'}"
          (buttonClick)="onGoClick()"
        >
          Go
        </oph-button>
      }
    </div>
  </div>

  @if (useAi() && goalOptions().length > 0) {
    <!-- Goal Options List -->
    <div class="goal-options">
      @for (optionState of optionStates(); track shouldAnimateOptions() ? $index + '-animated' : $index) {
        <cb-checkbox-option
          [option]="optionState"
          [inputValue]="optionState.text"
          (valueChange)="onOptionToggle($index, $event)"
          (inputChange)="onOptionTextChange($index, $event)"
        ></cb-checkbox-option>
      }
    </div>
  }
</div>
